import { CatalogProductInterface } from '@/libs/cpq-builder/product.interface';
import { CatalogCpqJson }          from '@/libs/cpq-builder/cpq-json.interface';
import { InjectionKey }            from 'vue';
import { Store, useStore }         from 'vuex';

export interface StateInterface {
  catalog: {
    products: CatalogProductInterface[]
  },
  cpq: CatalogCpqJson,
  form: any,
  footerContent: any,
  stepsContent: any,
  item: any,
  partnerKey: string | null,
  partnerData: any,
  lang: string,
  /**
   * 1 none
   * 2 credit card
   */
  paymentType: 1 | 2,
  loadingEdit: boolean,
}


// define store injection key
export const key: InjectionKey<Store<StateInterface>> = Symbol()
export let pageNumber = 1;

export function useDefaultStore () {
  return useStore(key)
}

export function getLocalOrDefaultLang() {
  return localStorage.getItem('lang') || 'sl-SI';
}

export function getLangFromUrlParam() {
  let lang = new URLSearchParams(window.location.search).get('lg');
  if(!lang) {
    lang = 'sl-SI';
  }
  localStorage.setItem('lang', lang!);
  return lang! || localStorage.getItem('lang') || 'en-US';
}

export function getPaymentTypeOrDefault(): 1 | 2 {
  return  ((+ (localStorage.getItem('paymentType') as any)) as any) || 1;
}

export function setLang(lang: string) {
  return localStorage.setItem('lang', lang);
}

export function setDefaultPageIndex() {
  pageNumber++; 
}

// if (pageNumber === 1 && window.location.href.includes('model')) {
//   this.$router.push('/shop/model');
// } else {
//   pageNumber++;
// }
